import { useCallback, useContext } from 'react';

import { gql, useMutation } from '@apollo/client';

import { LocalizationContext } from 'localization';
import { CHANGE_GOODS_QUANTITY } from 'modals/WarehouseModals/schema';
import { getNotificationData } from 'modals/WarehouseModals/utils';
import notificationService from 'services/notificationService';

import { IChangeQuantityArgs, IReturnValue } from './interfaces';

export const useChangeGoodsQuantity = (): IReturnValue => {
  const { t } = useContext(LocalizationContext);

  const [mutation, { client, loading }] = useMutation(CHANGE_GOODS_QUANTITY, {
    // refetchQueries: [GOODS],
  });

  const changeQuantity = useCallback(
    ({ goodId, quantity, operation, comment }: IChangeQuantityArgs) =>
      mutation({
        variables: {
          input: {
            items: [
              {
                id: goodId,
                quantity,
              },
            ],
            operation,
            ...(comment ? { comment } : {}),
          },
        },
      })
        .then(() => {
          const good = client.readFragment({
            id: client.cache.identify({ id: goodId, __typename: 'Good' }),
            fragment: gql`
              fragment good on Good {
                title
              }
            `,
          });

          notificationService.info(
            getNotificationData(t)(operation, good.title)
          );
        })
        .catch((e) => {
          const good = client.readFragment({
            id: client.cache.identify({ id: goodId, __typename: 'Good' }),
            fragment: gql`
              fragment good on Good {
                title
              }
            `,
          });
          notificationService.info({
            t,
            title:
              operation === 'ADD'
                ? t('notification.warehouse.add.error')
                : t('notification.warehouse.disposal.error'),
            message: good?.title,
            type: 'error',
          });
          throw e;
        }),
    [mutation]
  );

  return { changeQuantity, loading };
};
